module.exports = __webpack_public_path__ + "static/media/MT3.05dedc43.mp3";